import {Button} from '@/components/Connects/Button';
import {FormInput} from '@/components/Forms/FormInput/FormInput';
import {TeamColorSelectionModal} from '@/components/TeamColorSelection/TeamColorSelection';
import {useState} from 'react';
import {useForm} from 'react-hook-form';

export interface ClubTeamFormData {
  teamName: string;
  teamColor: string;
}

interface NativeInputFormData {
  teamName: string;
}

interface ClubTeamFormProps {
  onCancelHandler: () => void;
  onSubmitHandler: (data: ClubTeamFormData) => void;
  loading: boolean;
  error: string;
}

export const ClubTeamForm = ({onCancelHandler, onSubmitHandler, loading, error}: ClubTeamFormProps) => {
  const [teamColor, setTeamColor] = useState<string>('');
  const [showTeamColorSelectionModal, setShowTeamColorSelectionModal] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors, isSubmitted},
  } = useForm<NativeInputFormData>();

  const submitFormHandler = (data: NativeInputFormData) => {
    if (!teamColor) {
      return;
    }
    const teamData: ClubTeamFormData = {
      teamName: data.teamName.trim(),
      teamColor,
    };
    onSubmitHandler(teamData);
  };

  const onClickCancelHandler = () => {
    reset();
    onCancelHandler();
  };

  return (
    <form className="flex flex-col justify-center items-center" onSubmit={handleSubmit(submitFormHandler)}>
      <div className="w-full">
        <FormInput
          {...register('teamName', {required: 'Team Name is required'})}
          id="teamName"
          hasError={!!errors.teamName?.message}
          placeholder="Team Name"
          type="text"
        />
        <p className="text-xs text-alert m-1 text-left">{errors.teamName?.message ?? '\u00A0'}</p>
      </div>

      <div className="w-full mb-4">
        <button
          type="button"
          className="w-full h-12 bg-grey-xlight rounded-md"
          onClick={() => setShowTeamColorSelectionModal(true)}
        >
          <div className="flex items-center justify-between ml-4 mr-4">
            <span className="text-base text-grey-xdark font-light">
              {teamColor ? 'Team Color' : 'Select Team Color'}
            </span>
            <span style={{backgroundColor: teamColor || 'transparent'}} className="w-6 h-6"></span>
          </div>
        </button>

        <TeamColorSelectionModal
          activeColor={teamColor}
          isOpen={showTeamColorSelectionModal}
          closeModal={() => setShowTeamColorSelectionModal(false)}
          onColorSelectionHandler={setTeamColor}
        />
        {isSubmitted && !teamColor && <p className="text-xs text-alert m-1">Team color is required</p>}
      </div>

      {error && <p className="text-xs text-alert mb-1">{error}</p>}

      <div className="flex items-center justify-center mt-4">
        <Button text="Save" color="secondary" variant="cta" disabled={loading} />
        <Button className="ml-4" text="Cancel" color="primary" variant="standard" onClick={onClickCancelHandler} />
      </div>
    </form>
  );
};
